import React from "react";
import Paragraph from "../Paragraph";

const HeroAuthor = ({ ...props }) => {
	return <Paragraph className="section-hero__author" {...props} />;
};

HeroAuthor.propTypes = {
	...Paragraph.propTypes,
};

export default HeroAuthor;
